// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_93444fe79c--wrapper--RS7dp","title-container":"_93444fe79c--title-container--lgPt3","projects-list":"_93444fe79c--projects-list--R24yh"};